var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("DragAndDrop"),
      _vm._v(" "),
      _vm.selectedDocumentsIndex.length == 0
        ? _c("route-breadcrumb", {
            attrs: { routes: _vm.rutas, size: "is-small" },
          })
        : _c("MultipleSelectionBar", {
            on: {
              "unselect-documents": _vm.unselectDocuments,
              "move-multiple-documents": _vm.openMoveMultipleDocuments,
            },
          }),
      _vm._v(" "),
      _c("PlusButton", {
        on: {
          "create-folder": _vm.openCreateFolder,
          "create-composite-unit": _vm.openCreateCompositeUnit,
          "upload-documents": _vm.openUploadDocuments,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "section pt-4" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("explorador", {
              ref: "explorador",
              attrs: {
                idFolder: _vm.idFolder,
                rutas: _vm.rutas,
                selected: _vm.selected,
              },
              on: {
                "update:idFolder": function ($event) {
                  _vm.idFolder = $event
                },
                "update:id-folder": function ($event) {
                  _vm.idFolder = $event
                },
                "update:rutas": function ($event) {
                  _vm.rutas = $event
                },
                "update:selected": function ($event) {
                  _vm.selected = $event
                },
                "create-folder": _vm.openCreateFolder,
                "rename-document": _vm.openRenameDocument,
                "move-document": _vm.openMoveDocument,
                "drag-and-drop-move-documents":
                  _vm.openDragAndDropMoveMultipleDocuments,
                "drag-and-drop-upload-documents":
                  _vm.openDragAndDropUploadDocuments,
                "delete-document": _vm.openDeleteDocument,
                "preview-document": _vm.openPreviewDocument,
                "folder-permissions": _vm.openFolderPermissions,
                "move-multiple-documents": _vm.openMoveMultipleDocuments,
                "delete-multiple-documents": _vm.openDeleteMultipleDocuments,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }